<template>
    <v-sheet>
        <v-sheet v-if="instrument && client && location">
            <v-hover><v-chip 
                slot-scope="{ hover }"
                :class="`caption font-weight-thin text-uppercase mb-2 ml-2 text-center elevation-${hover ? 3 : 0}`"
                @click="close" absolute top left>
                <v-icon>keyboard_arrow_left</v-icon>back</v-chip>
            </v-hover>
            <BasicCard :title="`Anagrafica strumento`" >
                <template v-slot:action>
                    <v-btn v-if="families_obj[instrument.family].enabled" v-can="{obj_type:'instrument', action: 'operation'}" color="primary" @click.stop="openOperationDialog(instr)" fab small><v-icon class="pa-2">access_time</v-icon></v-btn>
                    <v-btn v-can="{obj_type:'instrument', action: 'edit'}" color="primary" @click.stop="editInstrument" fab small><v-icon class="pa-2" small>create</v-icon></v-btn>
                    <v-btn v-if="families_obj[instrument.family].enabled" v-can="{obj_type:'instrument', action: 'edit'}" color="primary" @click.stop="cloneInstrument" fab small><v-icon class="pa-2" small>file_copy</v-icon></v-btn>
                    <v-btn v-can="{obj_type:'instrument', action: 'remove'}" color="primary" @click.stop="openDeleteInstrumentConfirm" fab small><v-icon class="pa-2" small>delete</v-icon></v-btn>                
                </template>
                <RowComponent
                    :label="`modello`"
                    :value="instrument.model">
                </RowComponent>
                
                <RowComponent
                    :label="`marca`"
                    :value="instrument.manufacturer">
                </RowComponent>
                <RowComponent
                    :label="`numero seriale`"
                    :value="instrument.serno">
                </RowComponent>
                <RowComponent
                    :label="`famiglia`"
                    :value="families_obj[instrument.family].label">
                </RowComponent>
                <RowComponent
                    :label="`codice cliente/nome`"
                    :value="instrument.name">
                </RowComponent>
                <RowComponent
                    :label="`versione software`"
                    :value="instrument.sw_version">
                </RowComponent>
                <RowComponent
                    :label="`QRCode`"
                    :value="instrument.qr_code">
                </RowComponent>
                <RowComponent
                    :label="`descrizione`"
                    :value="instrument.description">
                </RowComponent>
                <div>&nbsp;
                    <AuthorInfo
                        :key="instrument.updated"
                        :created="instrument.created"
                        :created_by="instrument.created_by"
                        :updated="instrument.updated"
                        :updated_by="instrument.updated_by"/>
                </div>
            </BasicCard>
            <BasicCard :title="`Posizione`" v-if="!instrument.primary" class="text-left">
                <RowComponent
                    :label="`cliente`"
                    :value="client.name">
                    P.IVA: {{client.piva}}
                </RowComponent>
                <RowComponent
                    :label="`sede`"
                    :value="location.name">
                    {{location.address}} {{ location.addrNum }}<br/>
                    {{location.zip}} {{location.city}} ({{ location.district}})<br/>
                    {{location.country}}
                </RowComponent>
                <RowComponent v-if="instrument.department_id && location.departments[instrument.department_id]"
                    :label="`reparto`"
                    :value="location.departments[instrument.department_id].name">
                </RowComponent>                 
            </BasicCard>
            
            <BasicCard v-if="instrument.platforms.length>0">
                <template v-slot:title>
                    <div class="d-flex flex-grow-1 text-left" @click="c_expand.platforms=!c_expand.platforms">
                        Dispositivi
                    </div>
                </template>
                <template v-slot:action>
                    <span @click.stop="c_expand.platforms=!c_expand.platforms">
                        <v-icon v-if="c_expand.platforms">expand_less</v-icon>
                        <v-icon v-else>expand_more</v-icon>
                    </span>
                </template>
                <div v-if="c_expand.platforms">
                <div class="pt-4" v-for="(platform,idxPlat) in instrument.platforms" :key="idxPlat">
                    <v-divider></v-divider>
                    <div class="ma-2 font-weight-regular body-1 font-italic">DISPOSITIVO {{idxPlat+1}}</div>
                    <div class="d-flex flex-column body-2">
                    <RowComponent
                        v-if="isMultifunction()" 
                        :label="families_obj[platform.family].label"
                        :only_label="true">
                    </RowComponent>
                    <RowComponent
                        v-if="families_obj[platform.family].class!=undefined && families_obj[platform.family].class!=null && families_obj[platform.family].class.length>0"
                        :label="'classe'"
                        :value="getClassName(platform)">
                    </RowComponent>
                    <RowComponent
                        :label="'campo misura'"
                        :val_obj="true"
                        ><InstrumentPlatformInfo class="body-2 font-weight-black"
                            :o_data="platform"
                            :show_divider="false"
                            :show_class="false"
                            />
                    </RowComponent>
                    <!--RowComponent
                        :label="'tolleranza'"
                        :val_obj="true"
                        >
                        <div class="d-flex flex-column flex-grow-1">
                        <div class="d-flex flex-column flex-grow-1 flex-shrink-0" v-for="(d_tol,idx) in platform.tolerance" :key="idx">
                            <div class="d-flex">
                                <span class="d-flex font-weight-bold mr-3">{{ tol_dict[d_tol.t_type].text }}</span>
                                <div v-if="d_tol.t_type!='law'">
                                    <div class="d-flex flex-column " v-if="d_tol.value == 'instrument'">
                                        <div v-for="t_ins of d_tol.t_vals" :key="t_ins.test_type">
                                        <span class="mr-1">{{t_ins.test_type}} - {{t_ins.t_val | formatNumber }}</span><span v-if="t_ins.t_calc == 'perc'">%</span><span v-else>divisioni</span>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <span class="mr-1">{{d_tol.t_vals[0].t_val  | formatNumber }}</span><span v-if="d_tol.t_vals[0].t_calc == 'perc'">%</span><span v-else>divisioni</span>
                                    </div>
                                </div>
                            </div>
                            <v-divider v-if="idx < platform.tolerance.length-1" />
                        </div>
                        </div>
                    </RowComponent-->
                    <v-row my-1 v-if="platform.custom_data" >
                        <v-col cols="12">
                        <CustomData 
                            :o_data="platform.custom_data"
                            :family="platform.family"
                            :c_type="'object'"
                            :show_info="true"
                            ref="custom_data"/></v-col>
                    </v-row>
                    </div>
                </div>
                </div>
            </BasicCard>
            <BasicCard v-if="!instrument.primary">
                <template v-slot:title>
                    <div class="d-flex flex-grow-1 text-left" @click="c_expand.metro=!c_expand.metro">
                        Dati metrologici
                    </div>
                </template>
                <template v-slot:action>
                    <span @click.stop="c_expand.metro=!c_expand.metro">
                        <v-icon v-if="c_expand.metro">expand_less</v-icon>
                        <v-icon v-else>expand_more</v-icon>
                    </span>
                </template>
                <div v-if="c_expand.metro">
                <MetrologicalInfo
                    v-for="op_type of Object.keys(families_obj[instrument.family].report)"
                    :key="op_type"
                    :selected="isMetroSelected(instrument.metrological_info[op_type])"
                    :metro="instrument.metrological_info[op_type]"
                    :type="op_type"
                    :family="instrument.family"
                    :title="report_obj[op_type].name"
                    :show_info="true"
                    :ref="`metro_${op_type}`"
                ></MetrologicalInfo>
                </div>
            </BasicCard>
            <BasicCard v-if="reports">
                <template v-slot:title>
                    <div class="d-flex flex-grow-1 text-left" @click="c_expand.report=!c_expand.report">
                        Report
                    </div>
                </template>
                <template v-slot:action>
                    <span @click.stop="c_expand.report=!c_expand.report">
                        <v-icon v-if="c_expand.report">expand_less</v-icon>
                        <v-icon v-else>expand_more</v-icon>
                    </span>
                </template>
                <div v-if="c_expand.report">
                    <div v-if="reports_uncomplete && reports_uncomplete.length>0">
                        <div class="pa-2 text-h6 text-uppercase">Non completi</div>
                        <ReportItem
                            v-for="report of reports_uncomplete"
                            :key="report._id"
                            :report_id="report._id"
                            :show_instrument="false"
                            class="px-2">
                        </ReportItem>
                    </div>
                    <div v-if="Object.keys(reports).length>0">
                        <div class="pa-2 text-h6 text-uppercase">Completi</div>
                    </div>
                    <div v-for="key of Object.keys(reports)" :key="key">
                        <div v-if="key != 'uncomplete'">
                            <div v-if="reports[key] && reports[key].length>0" class="pa-2 text-subtitle-1">
                                {{ report_obj[key].name }}
                            </div>
                            <ReportItem
                                v-for="report of reports[key]"
                                :key="report._id"
                                :report_id="report._id"
                                :show_instrument="false"
                                class="px-2">
                            </ReportItem>
                        </div>
                    </div>    
                </div>
            </BasicCard>
        </v-sheet>
        <v-sheet v-else>
            <p>LOADING</p>
        </v-sheet>
        <InstrumentDialog
            ref="instrumentEdit"
            v-on:update_instrument="loadInstrument"
        />
        <BaseDialog
            :dialog="op_dialog.open"
            v-on:close_dialog="closeOperationDialog"
            >
            <template v-slot:title>
                Scegli intervento
            </template>
            <div>
                <v-row no-gutters v-if="op_dialog.instr">
                    <v-col cols="12">
                        <InstrumentItem 
                            :instrument_id="op_dialog.instr._id"
                            :show_client="!!!client_id"
                            :show_location="true"
                            :show_platform_capacity="false"
                            :can_change="false"
                            :disable_link="true"
                            />
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="d-flex justify-between">
                        <v-autocomplete v-if="w_ops.length > 0" dense outlined
                            label="interventi in corso"
                            v-model="op_dialog.op_id"
                            :items="w_ops"
                            item-value="_id"
                            :item-text="item => 'nr. '+item.value.order_nr +' del '+ formatDate(item.value.order_date)"
                            clearable
                            @change="updateClient"
                        ></v-autocomplete>
                        <v-spacer />
                        <v-btn v-can="{obj_type:'instrument', action: 'operation'}" color="action" class="ml-2" @click.stop="newOperation"><v-icon small class="ma-1">add_box</v-icon>nuovo intervento</v-btn>
                    </v-col>
                </v-row>
                <div class="d-flex align-center justify-center" v-if="!op_dialog.updating">
                    <v-btn :disabled="!op_dialog.op_id" class="ma-2" color="primary" @click.stop="saveOperation">aggiungi</v-btn>
                    <v-btn class="ma-2" text @click.stop="closeOperationDialog">annulla</v-btn>
                </div>
                <div class="d-flex align-center justify-center" v-else>
                    <span v-if="op_dialog.updated">
                        <v-btn class="ma-2" color="primary" @click.stop="editOperation">vai all'intervento</v-btn>
                        <v-btn class="ma-2" text @click.stop="closeOperationDialog">chiudi</v-btn>
                    </span>
                    <v-progress-circular v-else
                        indeterminate
                        size="64"
                        width="7"
                        color="primary"
                    ></v-progress-circular>
                </div>        
            </div>
        </BaseDialog>
        <ConfirmDialog
            :data="delete_confirm"
            v-on:close_dialog="closeDialog"
            v-on:confirm_result="onDeleteConfirm"/>
        

    </v-sheet>
</template>

<script>
// import _ from 'lodash'
import BasicCard from '../../components/utils/Basic_card.vue'
import AuthorInfo from '../../components/utils/AuthorInfo'
import RowComponent from '../../components/utils/RowComponent.vue'
import MetrologicalInfo from "./Instrument_utils/Metrological_info"
import InstrumentPlatformInfo from "./Instrument_utils/Instrument_platform_info"
import InstrumentDialog from "./InstrumentDialog"
import InstrumentItem from "./InstrumentItem.vue"
import BaseDialog from "../../components/dialogs/BaseDialog"
import ConfirmDialog from '../../components/dialogs/ConfirmDialog'
import CustomData from "./Instrument_utils/CustomData"
import ReportItem from "../reports/ReportItem"
import { formatDatefromTS } from '../../utils/commonUtils'
import { searchDesign, orderByFields } from "../../utils/dbUtility"
import {i_families, report_type, tolerance} from "../../utils/common.js"

export default {
    components: { 
        MetrologicalInfo, BasicCard, RowComponent, InstrumentPlatformInfo, CustomData, 
        ReportItem, AuthorInfo, InstrumentDialog, BaseDialog, ConfirmDialog, InstrumentItem
    },
    props: {
        i_id: {
            type: String,
            required: true,
            default: ''  // TODO DEBUG-ONLY
        },
        lock_client: {
            type: Boolean,
            required: false,
            default: false
        },
        back: {
            type: String,
            required: false,
            default: null
        }
    },
    data() {
        return {
            instrument: null,
            valid: true,
            client: null,
            location: null,
            families_obj: i_families,
            report_obj: report_type,
            tol_dict: {},
            c_expand: {
                platforms: false,
                metro: false,
                report: false,
            },
            reports: {},
            reports_uncomplete: [],
            w_ops: [],
            op_dialog: {
                open: false,
                instr_ids: [],
                op_id: '',
                client_id: '',
                loc_id: '',
                department_id: '',
                updating: false,
                updated: false
            },
            delete_confirm: {
                dialog: false,
                title: 'Archivia strumento',
                message: "Sei sicuro di voler archiviare lo strumento selezionato?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "delete", val: "elimina"}
                    ]
            },
        }
    },
    created() {
        this.tol_dict = _.keyBy(tolerance._type, t => t.id);
    },
    computed: {
    },
    methods: {
        formatDate(ts) {
            return formatDatefromTS(ts)
        },
        cloneInstrument(){
            this.$refs.instrumentEdit.openDialog({instrument_id: this.instrument._id, clone: true, 
                primary: this.instrument.primary,
                org_id: this.instrument.org_id});
        },
        openDeleteInstrumentConfirm(){
            console.log('DELETE')
            this.delete_confirm.message = "Sei sicuro di voler archiviare <br/><b>" + this.instrument.name+" / "+ this.instrument.serno+" - "+this.instrument.manufacturer+" - "+this.instrument.model+"</b>?"
            this.delete_confirm.dialog = true;
        },
        async onDeleteConfirm(choice){
            try {
                if(choice == "delete"){
                    this.instrument.updated_by = this.$store.state.user._id
                    this.instrument.updated = (new Date()).getTime()
                    this.instrument.dismissed = true
                    let res = await this.$store.state.$pouch.put('registry', this.instrument)
                    if (res.ok) {
                        this.instrument._rev = res.rev
                        this.$router.push("/instruments/")
                    }
                } 
                this.closeDialog()
            } catch(error) {
                console.log('error', error)
            }
        },
        closeDialog(){
            this.delete_confirm.dialog = false;
        },
        async saveOperation() {
            try {
                this.op_dialog.updating = true
                let op = await this.$store.state.$pouch.get('operations', this.op_dialog.op_id)
                op.instrument_ids = _.union(op.instrument_ids, this.op_dialog.instr_ids)
                if (this.op_dialog.department_id) {
                    //console.log('DEPARTMENT', this.op_dialog.department_id)
                    op.department_ids = _.union(op.department_ids, [this.op_dialog.department_id])
                }
                op.updated_by = this.$store.state.user._id
                op.updated = (new Date()).getTime()
                let opRes = await this.$store.state.$pouch.put('operations', op)
                this.op_dialog.updated = true
            } catch(error) {
                console.log('error', error)
            }
        },

        newOperation(){
            let query = {
                client_id: this.instrument.client_id,
                location_id: this.instrument.location_id,
                department_id: this.instrument.department_id,
                instr_ids: [this.instrument._id],
                back: this.$router.history.current.fullPath
            }
            this.$router.push({path: "/operations/edit", query: query})
            this.closeOperationDialog()
        },

        editOperation(){
            this.$router.push({path: "/operations/details", query: {
                op_id: this.op_dialog.op_id,
                instr_ids: this.op_dialog.instr_ids,
                back: this.$router.history.current.fullPath
                }
            })
            this.closeOperationDialog()
        },
        closeOperationDialog() {
            this.op_dialog.loc_id = null
            this.op_dialog.client_id = null
            this.op_dialog.instr_ids = []
            this.op_dialog.department_id = []
            this.op_dialog.instr = null
            this.op_dialog.updating = false
            this.op_dialog.updated = false
            this.op_dialog.op_id = ''
            this.op_dialog.open = false
        },
        async openOperationDialog() {
            // console.log('INSTR', instr)
            this.op_dialog.loc_id = this.instrument.location_id
            this.op_dialog.client_id = this.instrument.client_id
            this.op_dialog.instr_ids = [this.instrument._id]
            if (this.instrument.department_id){
                this.op_dialog.department_id = this.instrument.department_id
            }
            this.op_dialog.instr = this.instrument
            this.op_dialog.loc = this.$store.state.$pouch.get('registry', this.instrument.location_id)
            let ops = await searchDesign(this.$store.state.$pouch, 'operations', 'operations/searchByData', 'all_keys', [['org', this.$store.state.user.org_id],['location', this.op_dialog.loc_id], ['status', 'working']], false)
            let ops_w = await searchDesign(this.$store.state.$pouch, 'operations', 'operations/searchByData', 'all_keys', [['org', this.$store.state.user.org_id], ['location', this.op_dialog.loc_id], ['status', 'created']], false)
            ops = _.union(ops, ops_w)
            if (ops && ops.length>0) {
                ops = ops.map(item => { return { _id: item.id, value: item.value } })
                ops = ops.filter((op) => {
                    //console.log("OP_TYPE", op.value.op_type, Object.keys(this.families[this.instrument.value.family].report).includes(op.value.op_type))
                    //return true
                    return !op.value.op_type || Object.keys(i_families[this.instrument.family].report).includes(op.value.op_type)
                })
                this.w_ops = orderByFields(ops, {value: ['value.order_nr', 'value.updated'], order: ['asc', 'asc']})
                //console.log('res -', this.w_ops)
            
            } else {
                this.w_ops = []
            }
            this.op_dialog.open = true
        },
        isMetroSelected(metro) {
            return metro && !_.isEmpty(metro)
        },
        isMultifunction() {
            return i_families[this.instrument.family].multifunction
        }, 
        close(){
            this.$router.push({path: this.back})
        },
        getClassName(platform) {
            let idx = _.findIndex(this.families_obj[platform.family].class, function(c) { return c.id == platform.instrument_class; });
            console.log('INDICE', idx, this.families_obj[platform.family].class[idx])
            return this.families_obj[platform.family].class[idx].text
        },
        editInstrument(){
                //this.$router.push({path: '/instrument/edit'})
            this.$refs.instrumentEdit.openDialog({instrument_id: this.instrument._id, 
                lock_client: this.lock_client, 
                primary: this.instrument.primary,
                org_id: this.instrument.org_id});
        },
        async loadInstrument(id) {
            console.log("IDDDDDD", id)
            if (id && id != this.i_id) {
                this.$router.push({path: "/instruments/details", query: {i_id: id, back: '/instruments/'}})
            } else {
                let res = await this.$store.state.$pouch.get('registry', this.i_id)
                if (res) {
                    this.instrument = res
                    this.client = await this.$store.state.$pouch.get('registry', this.instrument.client_id)
                    this.location = await this.$store.state.$pouch.get('registry', this.instrument.location_id)
                    await this.searchReports()
                    // this.getClient()
                    // this.getLocation()
                }
            }
        },
        async searchReports(){
            this.reports = {}
            console.log('res REPORT', this.instrument._id)
            let res = await searchDesign(this.$store.state.$pouch, 'reports', 'reports/searchByData', 'key', this.instrument._id, false)
            if (res.length > 0) {
                res = res.map(item => { return { _id: item.id, value: item.value } })
                res = _.groupBy(res, function(rep) {
                    if (!['ready', 'ready_failed'].includes(rep.value.status)){
                        return 'uncomplete'
                    } else {
                        return rep.value.op_type
                    }
                })
                for (let key of Object.keys(res)){
                    if (key == 'uncomplete') {
                        this.reports_uncomplete = orderByFields(res[key], {value: ['value.report_date', 'value.review_date'], order: ['desc', 'desc']})
                    } else {
                        console.log('key', key)
                        this.reports[key] = orderByFields(res[key], {value: ['value.report_date', 'value.review_date'], order: ['desc', 'desc']})
                    }
                }
                
                // this.locations = orderByFields(res, {value: ['value.name', 'value.updated'], order: ['asc', 'asc']})
            } else {
                this.reports = null
            }
        }
    },
    async mounted(){
        console.log('§§§§§§§§§§§§§§ DETAILS', this.lock_client)
        await this.loadInstrument()
    }
}
</script>

<style>

</style>
